import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Loader from 'components/Loader';
import Libraries from 'components/Libraries';
import Media from './Media';
import NoMaterialContent from './NoContent';

import './AttendeeMaterialsContent.scss';

const updateLibraryRoute = 'library/:libraryID/PATCH';

const AttendeeMaterialsContent = props => {
	const { library, event, socket, auth0Token, from, handlePickItem } = props;
	const { libraries, media, id, name, hidden } = library;

	const [mediaContent, setMediaContent] = useState([]);
	const [fileTypes, setFileTypes] = useState([]);
	const [viewType, setViewType] = useState('gridView');
	const [sortOrder, setSortOrder] = useState([]);

	useEffect(() => {
		if (fileTypes.length) {
			const filteredMedia = media.nodes.filter(m => {
				const [primary, secondary] = m.mime_type.split('/');
				return fileTypes.includes(primary) || fileTypes.includes(secondary);
			});
			setMediaContent(filteredMedia);
		} else setMediaContent(media.nodes);
	}, [fileTypes, media]);

	useEffect(() => {
		if (library.sort_order) setSortOrder([library.sort_order]);
	}, [library.sort_order]);

	const changeSortOrder = sort_order => {
		const updatedLibrary = {
			id,
			sort_order,
			hidden,
			name,
		};

		socket.emit(updateLibraryRoute, updatedLibrary, event.id, auth0Token);
	};

	const handleMediaFilter = fileTypes => {
		setFileTypes(fileTypes);
	};

	if (!media) return <Loader />;
	if (!libraries.length && !media.nodes.length)
		return <NoMaterialContent iconType="library" from={from} eventID={event.id} />;
	return (
		<div className="AttendeeMaterialsContent">
			{from !== 'materialsPicker' ? (
				<Libraries libraries={libraries} eventID={event.id} handlePickItem={handlePickItem} />
			) : null}
			{from !== 'materialFoldersPicker' ? (
				<Media
					media={mediaContent}
					library={library}
					event={event}
					changeSortOrder={changeSortOrder}
					handleMediaFilter={handleMediaFilter}
					viewType={viewType}
					setViewType={setViewType}
					fileTypes={fileTypes}
					sortOrder={sortOrder}
					handlePickItem={handlePickItem}
				/>
			) : null}
		</div>
	);
};

const msp = ({ ws, auth }) => ({
	socket: ws.socket,
	auth0Token: auth.auth0Token,
});

const mdp = dispatch => ({});

export default connect(msp, mdp)(AttendeeMaterialsContent);
